var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManyPersons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F8F8FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643_9050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 18V16.6667C15.3337 15.9594 15.0527 15.2811 14.5526 14.781C14.0525 14.281 13.3742 14 12.667 14H7.33366C6.62641 14 5.94814 14.281 5.44804 14.781C4.94794 15.2811 4.66699 15.9594 4.66699 16.6667V18M19.3337 18V16.6667C19.3332 16.0758 19.1366 15.5018 18.7746 15.0349C18.4126 14.5679 17.9057 14.2344 17.3337 14.0867M14.667 6.08667C15.2406 6.23353 15.749 6.56713 16.1121 7.03487C16.4752 7.50261 16.6722 8.07789 16.6722 8.67C16.6722 9.26211 16.4752 9.83739 16.1121 10.3051C15.749 10.7729 15.2406 11.1065 14.667 11.2533M12.667 8.66667C12.667 10.1394 11.4731 11.3333 10.0003 11.3333C8.52757 11.3333 7.33366 10.1394 7.33366 8.66667C7.33366 7.19391 8.52757 6 10.0003 6C11.4731 6 12.667 7.19391 12.667 8.66667Z",
    stroke: "#5E639B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_9050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManyPersons);
export default __webpack_public_path__ + "static/media/ManyPersons.7479663262e366bff9d4dbdf6e5bcae7.svg";
export { ForwardRef as ReactComponent };